























import Vue from "vue";
import { mapGetters } from "vuex";
import { v4 as uuidv4 } from "uuid";
import iwInputSelect from "../buildingBlocks/InputSelect.vue";
import iwTooltip from "@/shared/components/Tooltip.vue";
import { floodSensitivity } from "@/shared/scripts/helpers/regulations/floodSensitivity.data";
import { FloodSensitivityPropertyInstance } from "@/shared/interfaces/FloodSensitivity.interface";
import { FloodSensitivityItem } from "@/shared/interfaces/FloodSensitivityItem.interface";

export default Vue.extend({
    name: "FloodSensitivityProperty",

    components: {
        iwInputSelect: iwInputSelect,
        iwTooltip: iwTooltip
    },

    data: function (): { path: string; specificId: string } {
        return {
            path: "property.constructionPermit.pScore",
            specificId: uuidv4()
        };
    },

    computed: {
        ...mapGetters({
            getClassifiedProperty: "FormModule/getValue",
            getError: "FormModule/getErrorObjectByPath",
        }),

        floodSensitivityValue: function(this: FloodSensitivityPropertyInstance): string {
            return this.getClassifiedProperty(this.path) || "";
        },

        error: function(this: FloodSensitivityPropertyInstance): string | null {
            const error = this.getError(this.path);
            return error || null;
        },

        label: function (): string {
            return this.$t("flood_sensitivity_p_score_short") as string;
        },

        options: function () {
            if (!this.$t) {
                return [];
            }

            return floodSensitivity().map((item: FloodSensitivityItem) => ({
                label: this.$t(item.label),
                value: item.value
            }));
        },

        id: function (): string {
            return "floodSensitivityProperty";
        },

        name: function (): string {
            return "flood-sensitivity-property";
        },

        tooltipTargetElementId: function(this: FloodSensitivityPropertyInstance): string {
            return `input-${this.name}-label-tooltip-${this.specificId}`;
        },

        tooltipText: function (): string {
            return this.$t("flood_zones_flanders_tooltip") as string;
        }
    },

    methods: {
        updateValue: function(this: FloodSensitivityPropertyInstance, value: string): void {
            if (value !== "") {
                this.$store.dispatch("FormModule/addValue", {
                    "path": this.path,
                    "value": value
                });
            } else {
                const current = this.getClassifiedProperty(this.path);
                if (current !== null) {
                    this.$store.commit("FormModule/deleteValue", this.path);
                }
            }
        }
    }
});
